import { render, staticRenderFns } from "./ChangeSummaryDataTable.vue?vue&type=template&id=19df323b&scoped=true&"
import script from "./ChangeSummaryDataTable.vue?vue&type=script&lang=js&"
export * from "./ChangeSummaryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSummaryDataTable.vue?vue&type=style&index=0&id=19df323b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df323b",
  null
  
)

export default component.exports